import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import { Helmet } from "react-helmet";
import axios from 'axios';
/* slick-carousel styles */
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import CarSlideshow from '../Carlist/CarSlideShow';

import './HomePage.css';
import HomePageIntro from './Homepageintro';
import RatingWithFeedback from '../Reviews/Reviews';
import ImageSlider from './Slideshow';

import CarListReview from '../Carlist/CarListReview';

export const imagesWithText = [
  { image: "/Image 1.jpg" },
  { image: "/Image 2.jpg"},
  { image: "/Image 3.jpg"}
];

function HomePage() {

  // State to store fetched car details
  


  const typewriterText = "Welcome to Zoom Autos!\nWhere you get your Favorite Car";

  return (
    <>
    <Helmet>
        <title>Home</title>
      </Helmet>
    <div className="homepage-container">
      

      <div className="carousel-container">
        <ImageSlider />
      </div>
      <CarSlideshow/>


      {/* Example of using the filters in a section */}
      
      


      
      <HomePageIntro />
      <RatingWithFeedback />

      
      
      
    </div>
    
    </>
  );
}

export default HomePage;
